import {Button, Group, Stack} from '@mantine/core';
import React, {useState} from 'react';

import RowByRowSubmissionSetting, {
  RowOnlyConfig,
} from 'notebook/structured-tables/components/RowByRowSubmissionSetting';
import ModalFooter from 'ui-library/modals/ModalFooter';
import {RunModalProps} from 'ui-library/runModal';

export interface StructuredTableSettingsModalValues {
  rowByRowSubmissionRequired?: boolean;
}

interface StructuredTableSettingsModalProps extends RunModalProps<StructuredTableSettingsModalValues> {
  locked: boolean;
  rowOnlyConfig: RowOnlyConfig;
}

export default function StructuredTableSettingsModal(props: StructuredTableSettingsModalProps): JSX.Element {
  const {showSubmissionSetting, rowOnlyInitialValue = false} = props.rowOnlyConfig;
  const [rowByRowSubmissionRequired, setRowByRowSubmissionRequired] = useState(rowOnlyInitialValue);

  return (
    <Stack spacing="sm">
      {showSubmissionSetting && (
        <RowByRowSubmissionSetting
          locked={props.locked}
          rowByRowSubmissionRequired={rowByRowSubmissionRequired}
          onRowByRowSubmissionRequiredChange={setRowByRowSubmissionRequired}
        />
      )}
      <ModalFooter>
        <Group position="right">
          <Button
            type="button"
            disabled={props.locked}
            onClick={() => props.close({rowByRowSubmissionRequired})}
          >
            Save
          </Button>
          <Button type="button" variant="secondary" onClick={() => props.close()}>
            Cancel
          </Button>
        </Group>
      </ModalFooter>
    </Stack>
  );
}
